const setNews = (state, payload) => {
    state.news = payload;
};
export default {
    setNews
};